export default __webpack_public_path__ + "static/media/login-bg-10.2015eae5.jpg";